import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AngularFireModule } from '@angular/fire';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MapComponent } from './tour/map/map.component';
import { TourComponent } from './tour/tour.component';
import { environment } from '../environments/environment';
import { InfoComponent } from './tour/info/info.component';
import { TimebarComponent } from './tour/info/timebar/timebar.component';
import { QuizComponent } from './tour/info/quiz/quiz.component';
import { AudioDirective } from './audio.directive';
import { ReflectionComponent } from './tour/info/reflection/reflection.component';
import { TestComponent } from './tour/info/test/test.component';
import { ZoomDirective } from './zoom.directive';
import { FocusDirective } from './tour/info/directives/focus.directive'
import { LocationPermissionComponent } from './tour/map/location-permission/location-permission.component';
import { WelcomeMapComponent } from './tour/map/welcome-map/welcome-map.component';
import { LottieModule } from 'ngx-lottie';
import { LocationLottieAnimationComponent } from './tour/location-lottie-animation/location-lottie-animation.component';
import { HomeComponent } from './tour/home/home.component';
import { SharedModule } from '@shared/shared.module';
import { TourStopMapModule } from './tour/tour-stop-map/tour-stop-map.module';

export function playerFactory() {
  return import('lottie-web');
}
@NgModule({
  declarations: [
    AppComponent,
    MapComponent,
    TourComponent,
    // InfoComponent,
    // TimebarComponent,
    // QuizComponent,
    // AudioDirective,
    // ReflectionComponent,
    // TestComponent,
    // ZoomDirective,
    // FocusDirective,
    // LocationPermissionComponent,
    // WelcomeMapComponent,
    // LocationLottieAnimationComponent,
    HomeComponent,
  ],
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    BrowserAnimationsModule,
    LottieModule.forRoot({player: playerFactory}),
    AppRoutingModule,
    SharedModule,
    TourStopMapModule,
    NgxMapboxGLModule.withConfig({
      accessToken: 'pk.eyJ1IjoibWF4aW11czg3NTQiLCJhIjoiY2tncmVxYm13MTI5aTJ4cDM3Nm1kZHd2ZiJ9.2j5T5zECqFQtjU47BzSlrw' // Optional, can also be set per map (accessToken input of mgl-map)
      // geocoderAccessToken: 'TOKEN'// Optional, specify if different from the map access token, can also be set per mgl-geocoder (accessToken input of mgl-geocoder)
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
